import { Container, Row, Col } from "react-bootstrap";
import "../assets/css/venue.css";
import heroImg from "../components/images/ranchWeddingImages/lakeside.jpg";
import eventDeck1 from "../components/images/ranchWeddingImages/eventDeck.jpg";
import eventDeck2 from "../components/images/ranchWeddingImages/lakeside1.jpg";
import eventDeck3 from "../components/images/ranchWeddingImages/image36.jpg";
import islandImg1 from "../components/images/ranchWeddingImages/deckHammer.jpg";
import islandImg2 from "../components/images/ranchWeddingImages/island.jpg";
import cascadeImg from "../components/images/ranchWeddingImages/image3.jpg";
import kellyImg1 from "../components/images/ranchWeddingImages/Kelly.jpg";
import kellyImg2 from "../components/images/ranchWeddingImages/Kelly2.jpg";
import grounds1 from "../components/images/ranchWeddingImages/sunset.jpg";
import grounds2 from "../components/images/ranchWeddingImages/pastureMountain.jpg";
import grounds3 from "../components/images/ranchWeddingImages/lakeside1.jpg";

export default function Venue() {
  return (
    <>
      <div className="venue-hero">
        <img className="venue-hero-img" src={heroImg} alt="Cascade Mountain Ranch" />
        <div className="venue-hero-overlay">
          <p className="venue-hero-eyebrow">Cascade Mountain Ranch</p>
          <h1>The Venue</h1>
          <p className="venue-hero-sub">50 Acres of Natural Beauty</p>
        </div>
      </div>

      <div className="venue-section">
        <Container>

          <div className="venue-category">
            <h2 className="venue-category-title">Event Deck</h2>
            <div className="venue-category-line"></div>
            <Row>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={eventDeck1} alt="Event Deck" />
                </div>
              </Col>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={eventDeck2} alt="Lakeside view from the event deck" loading="lazy" />
                </div>
              </Col>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={eventDeck3} alt="Event Deck exterior" loading="lazy" />
                </div>
              </Col>
            </Row>
            <p className="venue-category-desc">
              Perched on the edge of the upper lake, our Event Deck boasts over 6,000 sq ft, most
              of which is covered. With an on-site kitchen and gorgeous views, this is the perfect
              spot to host a reception.
            </p>
          </div>

          <div className="venue-category">
            <h2 className="venue-category-title">Island Gazebo — Coming Soon</h2>
            <div className="venue-category-line"></div>
            <Row>
              <Col md={6}>
                <div className="venue-img-wrap tall">
                  <img src={islandImg1} alt="Island Gazebo under construction" loading="lazy" />
                </div>
              </Col>
              <Col md={6}>
                <div className="venue-img-wrap tall">
                  <img src={islandImg2} alt="Island on the lower lake" loading="lazy" />
                </div>
              </Col>
            </Row>
            <p className="venue-category-desc">
              Currently under construction. A short walk through the forest will bring you to our
              secluded lower lake, where our Island Gazebo proudly sits. This natural beauty is our
              premier wedding location.
            </p>
          </div>

          <div className="venue-category">
            <h2 className="venue-category-title">Cascade Lodge</h2>
            <div className="venue-category-line"></div>
            <Row>
              <Col md={12}>
                <div className="venue-img-wrap full">
                  <img src={cascadeImg} alt="Cascade Lodge" loading="lazy" />
                </div>
              </Col>
            </Row>
            <p className="venue-category-desc">
              The Cascade is our rustic mountain lodge, perched high in the hills. From this
              vantage point you can see over the trees and bask in the beauty of the valley below
              and the mountains beyond. The Cascade Lodge's crowning glory is its 4,000 sq ft deck,
              which, with this picturesque backdrop, is a beautiful spot for smaller events. The
              lodge has 11 bedrooms sleeping up to 30 guests comfortably, 5 bathrooms, a penthouse
              suite with private bathroom and kitchenette, and a fully equipped kitchen.
            </p>
          </div>

          <div className="venue-category">
            <h2 className="venue-category-title">Kelly Lodge</h2>
            <div className="venue-category-line"></div>
            <Row>
              <Col md={6}>
                <div className="venue-img-wrap tall">
                  <img src={kellyImg1} alt="Kelly Lodge" loading="lazy" />
                </div>
              </Col>
              <Col md={6}>
                <div className="venue-img-wrap tall">
                  <img src={kellyImg2} alt="Kelly Lodge interior" loading="lazy" />
                </div>
              </Col>
            </Row>
            <p className="venue-category-desc">
              The Kelly is our bright and welcoming lodge that sits tucked up high in the tree line.
              The upper floor has a small balcony from which you can enjoy the breathtaking views.
              There are 10 bedrooms sleeping up to 30 guests comfortably, 6 bathrooms, and three
              kitchens — making this the perfect location for retreats or family reunions.
            </p>
          </div>

          <div className="venue-category">
            <h2 className="venue-category-title">The Grounds</h2>
            <div className="venue-category-line"></div>
            <Row>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={grounds1} alt="Sunset over the grounds" loading="lazy" />
                </div>
              </Col>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={grounds2} alt="Pasture and mountain view" loading="lazy" />
                </div>
              </Col>
              <Col md={4}>
                <div className="venue-img-wrap">
                  <img src={grounds3} alt="Lakeside grounds" loading="lazy" />
                </div>
              </Col>
            </Row>
            <p className="venue-category-desc">
              With 50 acres we have all the natural settings you could ask for — forests, fields,
              creeks, lakes, and mountain views. Take a stroll through our walking paths and you
              may come across turkeys, peacocks, deer, or even elk. If you don't spot any wildlife,
              ask the Ranch Host for a snack to feed our llamas.
            </p>
          </div>

        </Container>
      </div>
    </>
  );
}
